import { call, put, takeEvery } from 'redux-saga/effects';

import {
  loginFailed,
  loginSuccessed,
  loginSetApiError,
  LOGIN_FORM_SEND,
  LOGIN_FACEBOOK_FORM_SEND, LOGIN_CONFIRMED_USER
} from 'src/app/redux/actions/login/login';
import {
  feedbackMessageHide,
  feedbackMessageShow
} from 'src/app/redux/actions/feedbackMessage';
import {
  userIsUnauthorized,
  IS_LOGGED_IN_GET,
  userIsAuthorized
} from 'src/app/redux/actions/isLoggedIn';
import isLoggedInApi from 'src/app/api/isLoggedInApi';
import loginApi from 'src/app/api/loginApi';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import getReturnUrl from 'src/app/api/getReturnUrl';
import alerts from 'src/app/alerts.json';
import { apiErrorLogin } from 'src/app/redux/actions/apiError';
import { setLoginRedirection } from 'src/app/redux/actions/registration/confirmAccount';


const prepareLoginBody = (payload) => {
  const bodyParams = new Map([
    ['addFav', getWindowSearchParam('addFav')],
    ['addJa', getWindowSearchParam('addJa')]
  ]);

  const readyParams = [...bodyParams]
    .filter(([, value]) => !!value)
    .map(([key, value]) => ({ [key]: value }));

  return Object.assign({}, ...readyParams, payload);
};

const prepareLoginFacebookParams = (params) => params
  .map((param) => [param, getWindowSearchParam(param)])
  .filter(([, value]) => value)
  .map(([key, value]) => [key, encodeURIComponent(value)])
  .reduce((previous, [key, value]) => `${previous}&${key}=${value}`, '');

const prepareConfirmedLoginBody = () => ({
  userName: '',
  userId: getWindowSearchParam('userId'),
  password: getWindowSearchParam('loginToken')
});


// eslint-disable-next-line max-params
function loginUser(userOffline, loginSuccess, loginRequest, transformPayload, loginSuccessRedirection, setError) {
  return function* loginUserGenerator({ payload }) {
    yield put(setError(false));
    yield put(feedbackMessageHide());

    const loginRequestWithDispatchers = yield loginRequest(transformPayload(payload))
      .then(function* onSuccess() {

        loginSuccessRedirection();

        yield put(feedbackMessageShow(loginSuccess));

        return yield put(loginSuccessed());
      })
      .catch(function* onError({ response }) {
        yield put(setError(true));
        yield put(apiErrorLogin(response));
        yield put(loginFailed());
      });

    yield call(() => loginRequestWithDispatchers);
  };
}

function loginUserWithErrorHandle(prepareBody, setError) {
  return loginUser(
    alerts.userOffline,
    alerts.loginSuccess,
    loginApi.loginRequest,
    prepareBody,
    () => window.location.assign(getReturnUrl()),
    setError
  );
}

function loginFacebookUser(redirectAction) {
  return function* loginFacebookUserGenerator() {
    yield put(feedbackMessageHide());
    yield put(feedbackMessageShow(alerts.facebookRedirection));

    redirectAction();
  };
}

function isLoggedIn(isLoggedInRequest) {
  return function* isLoggedInGenerator() {
    yield put(feedbackMessageHide());

    const isLoggedInWithDispatchers = yield isLoggedInRequest()
      .then(function* onSuccess () {
        return yield put(userIsAuthorized());
      })
      .catch(function* onError () {
        yield put(userIsUnauthorized());
      });

    yield call(() => isLoggedInWithDispatchers);
  };
}


export { loginFacebookUser, loginUser };

export default [
  takeEvery(LOGIN_CONFIRMED_USER, loginUserWithErrorHandle(prepareConfirmedLoginBody, setLoginRedirection)),
  takeEvery(LOGIN_FORM_SEND, loginUserWithErrorHandle(prepareLoginBody, loginSetApiError)),
  takeEvery(LOGIN_FACEBOOK_FORM_SEND, loginFacebookUser(
    () => {
      const params = prepareLoginFacebookParams(['returnUrl', 'addFav', 'addJa']);

      window.location.assign(loginApi.loginFacebook(params));
    }
  )),
  takeEvery(IS_LOGGED_IN_GET, isLoggedIn(isLoggedInApi.getIsLoggedIn))
];
